(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/game-package-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/game-package-slice.js');

'use strict';

const {
  createSlice
} = RTK;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  packageConfig
} = svs.gamePackage.data;
const {
  packageSizes,
  drawsOptions,
  defaultSelectedIndex = 1,
  title,
  specialDrawsRule
} = packageConfig;
const {
  getPackageDraws,
  calculatePackagePriceFromConfig
} = svs.gamePackage.mappers;
const mapPackageSizes = (_ref, index) => {
  let {
    label,
    gamePackageId,
    games,
    tickets
  } = _ref;
  return {
    label,
    price: calculatePackagePriceFromConfig({
      games,
      tickets
    }),
    gamePackageId,
    index
  };
};
const gamePackageSlice = createSlice({
  name: 'gamePackage',
  initialState() {
    const activeIndex = defaultSelectedIndex;
    const draws = getPackageDraws({
      drawsOptions,
      specialDrawsRule
    });
    return {
      sizes: packageSizes.map(mapPackageSizes),
      activeIndex,
      packageIsClosed: !isSelfService && draws.length < drawsOptions.length,
      title
    };
  },
  reducers: {
    updateIndex: (state, action) => {
      state.activeIndex = parseInt(action.payload.activeIndex, 10);
    },
    updateDraws: (state, action) => {
      const draws = action.payload;
      state.packageIsClosed = !isSelfService && draws.length < drawsOptions.length;
      state.sizes = packageSizes.map(mapPackageSizes);
    }
  }
});
svs.gamePackage.redux.gamePackageSlice = gamePackageSlice;

 })(window);